// extracted by mini-css-extract-plugin
export default {"button":"ReplayButton_button__btltX"};